import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const FALLBACK_BANNER =
  "/pictures/banner_main.jpg";

const PAGE_TITLES = {
  "life-at-tigps": "Life at TIGPS",
  "academics": "Academics",
  "aep-questions-hub": "AEP Questions Hub",
  "demo-question-hub": "AEP Questions Hub",
  "aep-digital-library": "AEP Digital Library",
  "admissions": "Admissions",
  "about": "About Us",
  "mandatory-public-disclosure": "Mandatory Public Disclosure",
  "contact": "Contact Us"
};

const PAGE_SUBTITLES = {
  "aep-digital-library": "Study Materials, Videos, Assignments for Class VIII to XII",
  "aep-questions-hub": "Question Hub (JEE Main, JEE Advanced, NEET, VIII - XII (CBSE))",
  "demo-question-hub": "Question Hub (JEE Main, JEE Advanced, NEET, VIII - XII (CBSE))"
};

const SchoolInnerPageBanner = () => {
  const { school_slug } = useParams();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState(null);

  /* ---------------- FETCH SETTINGS ---------------- */
  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    axios
      .get(
        `${baseAPIUrl}api/general_settings/get_general_settings/${school_slug}`
      )
      .then(res => {
        if (res.data.status === 1) {
          setInfo(res.data.data.settings);
        }
      })
      .catch(err => console.error("API ERROR:", err))
      .finally(() => setLoading(false));
  }, [school_slug]);

  /* ---------------- PAGE TITLE FROM URL ---------------- */
  const getPageTitle = () => {
    const lastSegment = location.pathname.split("/").pop();
    return PAGE_TITLES[lastSegment] || "About";
  };

  /* ---------------- PAGE SUBTITLE FROM URL ---------------- */
  const getPageSubtitle = () => {
    const lastSegment = location.pathname.split("/").pop();
    return PAGE_SUBTITLES[lastSegment] || "";
  };

  /* ---------------- BANNER IMAGE ---------------- */
  const bannerImage = info?.page_banner
    ? `${baseAPIUrl}assets/images/settings/${info.page_banner}`
    : FALLBACK_BANNER;

  return (
    <div
      style={{
        position: "relative",
        height: "60vh",
        overflow: "hidden"
      }}
    >
      <img
        src={bannerImage}
        alt="School Banner"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover"
        }}
      />

      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(0,0,0,0.35)",
          textAlign: "center",
          padding: "0 20px"
        }}
      >
        <h3
          style={{
            color: "#fff",
            fontSize: "clamp(2rem, 5vw, 3.5rem)",
            fontWeight: 600,
            letterSpacing: "1px",
            margin: 0
          }}
        >
          {getPageTitle()}
        </h3>
        {getPageSubtitle() && (
          <p
            style={{
              color: "rgba(255, 255, 255, 0.95)",
              fontSize: "clamp(1rem, 2vw, 1.3rem)",
              fontWeight: 400,
              marginTop: "12px",
              marginBottom: 0,
              maxWidth: "900px",
              letterSpacing: "0.5px"
            }}
          >
            {getPageSubtitle()}
          </p>
        )}
      </div>
    </div>
  );
};

export default SchoolInnerPageBanner;
